import * as timeDelta from 'time-delta';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import enLocale from 'time-delta/locales/en';
import frLocale from 'time-delta/locales/fr';
import esLocale from 'time-delta/locales/es';
import deLocale from 'time-delta/locales/de';
import ptLocale from 'time-delta/locales/pt';
import itLocale from 'time-delta/locales/it';
import nbLocale from 'time-delta/locales/nb';
import plLocale from 'time-delta/locales/pl';
import nlLocale from 'time-delta/locales/nl';

timeDelta.addLocale([enLocale, frLocale, esLocale, deLocale, ptLocale, itLocale, nbLocale, plLocale, nlLocale]);
const instance = timeDelta.create({
    locale: 'en',
    span: 1,
  });

// Map our app language codes to time-delta locale codes
const localeMap = { no: 'nb', 'en-US': 'en', 'en-GB': 'en', 'pt-BR': 'pt', 'fr-FR': 'fr', 'es-ES': 'es', 'de-DE': 'de', 'it-IT': 'it', 'nl-NL': 'nl', 'pl-PL': 'pl' };

export function timeDeltaToString(date1, date2, config) {
    let lang = (config && config.locale) || i18n.language || 'en';
    // Normalize locale codes like 'en-US' to base language 'en'
    if (lang.includes('-')) lang = lang.split('-')[0];
    const locale = localeMap[lang] || lang;
    return instance.format(date1, date2, { ...config, locale })
}

export function useGetTimeDelta() {
    const { t } = useTranslation();
    return (timeString) => {
        const currentTime = new Date();
        const targetTime = new Date(timeString);
        const timeDiff = currentTime - targetTime;
        const seconds = Math.floor(timeDiff / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        if (seconds < 60) return t('common.time.justNow');
        else if (minutes < 60) return t('common.time.minutesAgo', { count: minutes });
        else if (hours < 24) return t('common.time.hoursAgo', { count: hours });
        else return t('common.time.daysAgo', { count: days });
    };
}
